import { merge } from 'lodash'
import Block from './block'

class ImagesBlock extends Block {

  constructor(block) {
    super(block)
    this.type = 'images'
    this.alias = `雙圖 - ${this.uid}`
    this.mobile = {
      images: [
        {
          url: '',
          size: 0,
          width: 0,
          height: 0,
          title: ''
        },
        {
          url: '',
          size: 0,
          width: 0,
          height: 0,
          title: ''
        }
      ]
    }
    this.desktop = {
      images: [
        {
          url: '',
          size: 0,
          width: 0,
          height: 0,
          title: ''
        },
        {
          url: '',
          size: 0,
          width: 0,
          height: 0,
          title: ''
        }
      ]
    }
    this.linkables = [
      {
        type: 'href',
        href: '',
        title: ''
      },
      {
        type: 'href',
        href: '',
        title: ''
      }
    ]

    if (block) {
      merge(this, block)
    }
  }

}

export default ImagesBlock



// WEBPACK FOOTER //
// ./src/models/blocks/images.js